import { render, staticRenderFns } from "./TakeAPhoto.vue?vue&type=template&id=21b6238d&scoped=true&"
import script from "./TakeAPhoto.vue?vue&type=script&lang=js&"
export * from "./TakeAPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b6238d",
  null
  
)

export default component.exports